import { Box } from '@mui/material'
import { LeadForm } from '@/modules/shared/widgets'
import { Container, Section } from '@/fractals/components'
import {
  illustrationDesktop,
  illustrationLaptop,
  illustrationTablet,
  illustrationMobile
} from './fractals'
import { useMedia } from '@/fractals/hooks'

const LeadFormPsychology = () => {
  const { isMobile } = useMedia()

  return (
    <Section
      id='lead-form'
      spacingVariant='beta'
      colorsVariant='delta'
      styles={{
        '*': { boxSizing: 'border-box' }
      }}>
      <Container>
        <Box
          display='grid'
          gridTemplateColumns='repeat(2, 1fr)'
          gridTemplateRows='404px'
          gap='32px'
          sx={{
            '@media (max-width: 1280px)': {
              gap: '24px',
              gridTemplateColumns: '1fr',
              gridTemplateRows: '334px auto'
            },
            '@media (max-width: 426px)': {
              gridTemplateRows: '343px auto'
            }
          }}>
          <Box
            width='100%'
            height='100%'
            borderRadius='16px'
            sx={{
              backgroundImage: `url(${illustrationDesktop.default.src})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              '@media (max-width: 1280px)': {
                backgroundImage: `url(${illustrationLaptop.default.src})`
              },
              '@media (max-width: 768px)': {
                backgroundImage: `url(${illustrationTablet.default.src})`
              },
              '@media (max-width: 426px)': {
                backgroundImage: `url(${illustrationMobile.default.src})`
              }
            }}
          />
          <LeadForm
            heading='Получите полную программу курса на личной консультации'
            buttonValue={
              isMobile ? 'Отправить заявку' : 'Получить подробный учебный план'
            }
            styleVariant='gamma'
            colorsVariant='delta'
            formName='FORM Psychology'
            name
            phoneNumber
            email
            promocode
            isLabel={!isMobile}
            isPsychology
            id='LeadFormPsychology'
          />
        </Box>
      </Container>
    </Section>
  )
}

export default LeadFormPsychology
